import { render, staticRenderFns } from "./TagsSelectInput.vue?vue&type=template&id=671f0e3d&"
import script from "./TagsSelectInput.vue?vue&type=script&lang=js&"
export * from "./TagsSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports